import { render } from "./ApartmentsNotesBuyer.vue?vue&type=template&id=f7ee83e4"
import script from "./ApartmentsNotesBuyer.vue?vue&type=script&lang=js"
export * from "./ApartmentsNotesBuyer.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__